import { HeaderBackMusicHallWidgetStyled } from "./styled";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import { Icons } from "components";

const HeaderBackMusicHallWidget = ({ room_booking_id }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { t } = useTranslation(["common"]);

  const _handleClickBack = () => {
    let query = {
      ...queryString.parse(location.search),
    };
    delete query.is_preview;
    const queryStringTemp = new URLSearchParams({
      ...query,
    }).toString();
    navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${room_booking_id}/booking/1?${queryStringTemp}`
    );
  };

  return (
    <HeaderBackMusicHallWidgetStyled>
      <div className="btn_hdb" onClick={_handleClickBack}>
        <Icons.ArrowLeft2 color="#482174" />
      </div>
      <div className="hdb_label_block" onClick={_handleClickBack}>
        {/* <Icons.Home /> */}
        {t("Back to Edit Information", { ns: "common" })}
      </div>
    </HeaderBackMusicHallWidgetStyled>
  );
};

export default HeaderBackMusicHallWidget;
